export const secondToHour = (seconds: number) => {
  const MINUTE = 60;
  const HOUR = 60 * MINUTE;

  let hour = 0;
  let minute = 0;
  let second = 0;

  if (seconds / HOUR > 0) {
    hour = Math.floor(seconds / HOUR);
    minute = Math.floor((seconds % HOUR) / MINUTE);
    second = Math.floor((seconds % HOUR) % MINUTE);
  }

  const addZero = (time: number) => {
    if (time < 10) {
      return "0" + time;
    }

    return time;
  };

  return `${addZero(hour)} : ${addZero(minute)} : ${addZero(second)}`;
};

// date to 22 May 2022
export const dateToString = (d: string) => {
  const date = new Date(d);
  const month = date.getMonth() + 1;
  const day = date.getDate();
  const year = date.getFullYear();

  return `${day}-${month}-${year}`;
};
